import { Component, Input, OnInit } from '@angular/core';
import { DataService } from '../../services/data.service';
import {
  faArrowAltFromLeft,
  faPlay,
  faStop,
  faPause,
  faFastForward,
  faFileInvoice,
  faFileCheck,
  faFileUser,
  faStreetView,
  faUsers,
  faBars,
  faPowerOff,
  faSlidersH
} from '@fortawesome/pro-light-svg-icons';
import { ElementModel } from '../../models/element.model';
import { UserModel } from '../../models/user.model';

@Component({
  selector: 'app-element',
  templateUrl: './element.component.html',
  styleUrls: ['./element.component.scss']
})
export class ElementComponent implements OnInit {

  @Input() element: ElementModel = null;
  @Input() user: UserModel = null;

  public status: any = null;

  // icons
  public faArrowAltFromLeft = faArrowAltFromLeft;
  public faPlay = faPlay;
  public faStop = faStop;
  public faPause = faPause;
  public faFastForward = faFastForward;
  public faFileInvoice = faFileInvoice;
  public faFileCheck = faFileCheck;
  public faFileUser = faFileUser;
  public faStreetView = faStreetView;
  public faUsers = faUsers;
  public faBars = faBars;
  public faPowerOff = faPowerOff;
  public faSlidersH = faSlidersH;
  constructor(
    private data: DataService
  ) { }

  ngOnInit(): void {
    // this.data.userStatus$.subscribe((status: any) => this.status = status);
  }

  setActive(): void {
    this.data.setActiveElement(this.element.id);
  }

}
